import React from "react";

const SingleBlogCategory = ({ category }) => {
  return (
    <div className="blog-category">
      <a
        href={category.href}
        dangerouslySetInnerHTML={{ __html: category.content }}
      />
    </div>
  )
};

export default SingleBlogCategory;
